const UnorderedList = (props) => {
  const itemList = props.items_list.map(function (item, index) {
    return <li key={index}> {item} </li>;
  });
  return (<ul className="simple_list">{itemList}</ul>);
};

export default UnorderedList;
